import { render, staticRenderFns } from "./flow-chart.vue?vue&type=template&id=39b5aa40"
import script from "./flow-chart.vue?vue&type=script&lang=js"
export * from "./flow-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports